import React from 'react';
import PropTypes from 'prop-types';

const Duplex = ({ className, checked }) => (
    <svg
        width="56px"
        height="56px"
        viewBox="0 0 56 56"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className} ${checked ? 'path__fill__checked' : 'path__fill'}`}
    >
        <title>Duplex</title>
        <desc>Created with Sketch.</desc>
        <g
            id="assets"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            fillOpacity="0.6"
        >
            <g id="Duplex" fill="#393939">
                <path
                    d="M33,44 L33,34 L33,27 C33,24.243 30.757,22 28,22 C25.243,22 23,24.243 23,27 L23,34 L23,44 L17,44 L17,18.618 L28,13.118 L39,18.618 L39,44 L33,44 Z M25,44 L31,44 L31,35 L25,35 L25,44 Z M31,33 L25,33 L25,27 C25,25.346 26.346,24 28,24 C29.654,24 31,25.346 31,27 L31,33 Z M45,44 L41,44 L41,18 C41,17.621 40.786,17.275 40.447,17.105 L28.447,11.105 C28.166,10.965 27.834,10.965 27.553,11.105 L15.553,17.105 C15.214,17.275 15,17.621 15,18 L15,44 L11,44 C10.448,44 10,44.447 10,45 C10,45.553 10.448,46 11,46 L16,46 L24,46 L32,46 L40,46 L45,46 C45.553,46 46,45.553 46,45 C46,44.447 45.553,44 45,44 L45,44 Z"
                    id="Page-1"
                />
            </g>
        </g>
    </svg>
);

Duplex.displayName = 'Duplex';

Duplex.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
};

/**
 * Duplex Functional Component.
 */
export default Duplex;
